import { useState } from "react";
import Header from "../../components/Header";
import ModalConfirmLogout from "../../components/ModalConfirmLogout";
import { useNavigate } from "react-router-dom";

const imageCasino = [
  {
    url: "assets/NH/menuGame/PG.png",
    link: "/PG",
    name: "PG ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/GAMING.png",
    link: "/759_GAMING",
    name: "759 GAMING",
  },
  {
    url: "assets/NH/menuGame/AG.png",
    link: "/AG",
    name: "AG ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/AP.png",
    link: "/AP",
    name: "AP ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/BNG.png",
    link: "/BNG",
    name: "BNG ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/CQ9.png",
    link: "/CQ9",
    name: "CQ9 ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/DG.png",
    link: "/DG",
    name: "DG ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/EVOPLAY.png",
    link: "/EVOPLAY",
    name: "EVOPLAY ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/FASHPIN.png",
    link: "/FASHPIN",
    name: "FASHPIN ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/FC.png",
    link: "/FC",
    name: "FC ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/FUNKY.png",
    link: "/FUNKY",
    name: "FUNKY ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/GENESIS.png",
    link: "/GENESIS",
    name: "GENESIS ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/HB.png",
    link: "/HB",
    name: "HB ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/JDB.png",
    link: "/JDB",
    name: "JDB ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/JILI.png",
    link: "/JILI",
    name: "JILI ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/LIVE22.png",
    link: "/LIVE22",
    name: "LIVE22 ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/MG.png",
    link: "/MG",
    name: "MG ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/NE.png",
    link: "/NE",
    name: "NE ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/NOLIMIT.png",
    link: "/NOLIMIT",
    name: "NOLIMIT ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/NS.png",
    link: "/NS",
    name: "NS ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/PP.png",
    link: "/PP",
    name: "PP ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/PS.png",
    link: "/PS",
    name: "PS ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/PT.png",
    link: "/PT",
    name: "PT ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/R88.png",
    link: "/R88",
    name: "R88 ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/REDTIGER.png",
    link: "/REDTIGER",
    name: "REDTIGER ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/SPADEGAMING.png",
    link: "/SPADEGAMING",
    name: "SPADEGAMING ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/SPRIBE.png",
    link: "/SPRIBE",
    name: "SPRIBE ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/VA.png",
    link: "/VA",
    name: "VA ĐIỆN TỬ",
  },
];


const HomeNH = () => {
  const [isShowLogout, setIsShowLogout] = useState(false);
  const navigate = useNavigate();

  const handleClick = (e: string) => {
    navigate(`/NH/slot${e}`);
  };

  return (
    <div>
      <Header setIsShowLogout={() => setIsShowLogout(true)} />
      <div className="container-fluid lobby-bg position-relative  mx-auto  mb-5 max-w-screen-xl">
        <div className="container mx-auto">
          <div className="flex flex-wrap my-7">
            <div className="w-1/2 md:w-2/3">
              <img
                src="/assets/NH/SLOT_ROOM_ai.png"
                alt="Slot"
                className="!w-[50%] h-auto"
              />
            </div>
            <div className="w-1/2 md:w-1/3 flex justify-center items-center">
              <a href="/" className="text-white no-underline">
                <div className="text-white px-4 py-2 rounded-lg shadow box-goto-lobby w-[10rem]">
                  Quay lại
                </div>
              </a>
            </div>
          </div>
          <div
            id=""
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 pt-3 all-programs py-8 mb-10"
          >
            {imageCasino.map((e) => {
              return (
                <div
                  data-aos="flip-left"
                  data-aos-delay="100"
                  className="mb-1 aos-init aos-animate cursor-pointer transition-transform transform duration-300 ease-in-out hover:scale-110"
                  onClick={() => handleClick(e.link)}
                >
                  <div className="box-game w-[80%] mx-auto group">
                    <img
                      src={e.url}
                      alt="SA Casino Gaming"
                      className="w-full transition duration-300 ease-in-out group-hover:drop-shadow-[0_0_10px_#1e943b]"
                    />
                    <label className="mt-2 font-semibold text-white text-center block transition duration-300 ease-in-out group-hover:drop-shadow-[0_0_6px_#1e943b]">
                      {e.name}
                    </label>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <ModalConfirmLogout
        isShowLogout={isShowLogout}
        setIsShowLogout={() => {
          setIsShowLogout(false);
        }}
      />
    </div>
  );
};

export default HomeNH;
